<cerrix-loader [cerrixTab]="tab"></cerrix-loader>
@if (config) {
    <generic-list-manager [config]="config"></generic-list-manager>
}

<ng-template #roleGroupInfo>
    @if (details) {
        <div class="basic-details">
            <div class="form-group">
                <cerrix-textfield
                    fieldLabel="Name"
                    [(ngModel)]="details.name"
                    placeholder="Required"
                ></cerrix-textfield>
            </div>
            <div class="form-group">
                <label>Description</label>
                <cerrix-textarea [(ngModel)]="details.description"></cerrix-textarea>
            </div>
        </div>
    } @else {
        <div class="fancy-loader"></div>
    }
</ng-template>

<ng-template #selectedRoles>
    @if (details) {
        <role-assign [moduleRoles]="details.moduleRoles" [allowChange]="true"></role-assign>
    }
</ng-template>

<ng-template #selectedUsers>
    <div class="detail-page-action-bar">
        <div class="right-area">
            <button (click)="toggleAll(true)" class="btn btn-dark">
                <i class="fas fa-check-square"></i>
                <span class="ms-2">Select all</span>
            </button>

            <button (click)="toggleAll(false)" class="btn btn-dark">
                <i class="fas fa-square"></i>
                <span class="ms-2">Deselect all</span>
            </button>
        </div>
    </div>

    <input
        class="form-control form-control-sm mb-2"
        placeholder="Quick search / filter users"
        [(ngModel)]="userFilter"
        (debounce-input-event)="filterUsers()"
    />
    @if (userFilterNoResults) {
        <span>There are no users found matching search criteria.</span>
    }
    @if (details) {
        <div class="user-select">
            @for (user of details.detailedUsers; track user) {
                <div
                    class="user-card text-truncate"
                    [hidden]="user._hidden"
                    [title]="user.lastname + ', ' + user.firstname"
                >
                    <cerrix-checkbox
                        [label]="user.lastname + ', ' + user.firstname"
                        [(value)]="user.checked"
                        fontweight="normal"
                    ></cerrix-checkbox>
                </div>
            }
        </div>
    }
</ng-template>

<ng-template #selectedDashboards>
    @if (details) {
        <div class="dashboard-select row">
            @for (dashboard of details.dashboards; track dashboard) {
                <div class="dashboard-item col-4">
                    <div
                        class="list-group-item list-group-item-action"
                        [class.active]="dashboard.checked"
                        (click)="dashboard.checked = !dashboard.checked"
                    >
                        <div class="d-flex w-100 justify-content-between">
                            <h5 class="mb-1">{{ dashboard.name }}</h5>
                            <small>{{ dashboard.updatedOn | dateTimeFormat }}</small>
                        </div>
                        <p class="mb-1">
                            {{ dashboard.createdBy }}
                        </p>
                        <div class="text-truncate" [matTooltip]="dashboard.description">
                            <small>{{ dashboard.description }}</small>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
</ng-template>

<ng-template #summary>
    @if (details) {
        <div class="summary">
            <div class="form-group">
                <cerrix-textfield
                    fieldLabel="Name"
                    [(ngModel)]="details.name"
                    [readonly]="true"
                ></cerrix-textfield>
                @if (!details.name) {
                    <small class="text-danger">Name is required!</small>
                }
            </div>
            <div class="form-group">
                <label>Description</label>
                <cerrix-textarea
                    [(ngModel)]="details.description"
                    [readonly]="true"
                ></cerrix-textarea>
            </div>
            <div class="form-group">
                <label>Selected roles</label>
                <div class="selected-tags">
                    @for (module of details.moduleRoles; track module) {
                        @for (role of module.roles; track role) {
                            @if (role.checked) {
                                <span class="badge bg-primary">{{ role.roleName }}</span>
                            }
                        }
                    }
                </div>
            </div>
            <div class="form-group">
                <label>Selected users</label>
                <div class="selected-tags">
                    @for (user of details.detailedUsers; track user) {
                        @if (user.checked) {
                            <span class="badge bg-primary">{{
                                user.lastname + ", " + user.firstname
                            }}</span>
                        }
                    }
                </div>
            </div>
            <div class="form-group">
                <label>Selected dashboards</label>
                <div class="selected-tags">
                    @for (dashboard of details.dashboards; track dashboard) {
                        @if (dashboard.checked) {
                            <span class="badge bg-primary">{{ dashboard.name }}</span>
                        }
                    }
                </div>
            </div>
        </div>
    }
</ng-template>

@if (wizardConfig) {
    <cerrix-wizard
        [config]="wizardConfig"
        #wizard
        [templates]="[roleGroupInfo, selectedRoles, selectedUsers, selectedDashboards, summary]"
    >
    </cerrix-wizard>
}
